import { ref } from 'vue'

// One source of truth for "is this the mobile layout". Before this existed,
// fifteen components each kept their own `window.innerWidth <= 768` ref plus a
// `resize` listener (LinkCard registered one PER CARD), and useViewSettings
// disagreed with everyone else by using `<` instead of `<=`.
//
// i18n-free and Vue-only: LinkCard imports this, so it is part of the embed
// bundle closure (tests/embedNoI18n.test.js).

export const MOBILE_BREAKPOINT_PX = 768

/** Synchronous check for one-off decisions (scroll-into-view, sidebar init). */
export function isMobileViewport() {
  if (typeof window === 'undefined') return false
  return window.innerWidth <= MOBILE_BREAKPOINT_PX
}

/**
 * Touch-first device? Drives whether swipe settings are worth showing at all.
 * matchMedia is the reliable signal; the touch-points fallback covers jsdom
 * and very old browsers.
 */
export function isCoarsePointer() {
  if (typeof window === 'undefined') return false
  if (typeof window.matchMedia === 'function') {
    try {
      return window.matchMedia('(pointer: coarse)').matches
    } catch {
      // fall through to the capability check
    }
  }
  return ('ontouchstart' in window) || ((typeof navigator !== 'undefined' && navigator.maxTouchPoints) || 0) > 0
}

let sharedIsMobile = null

function ensureSharedRef() {
  if (sharedIsMobile) return sharedIsMobile
  sharedIsMobile = ref(isMobileViewport())
  if (typeof window !== 'undefined') {
    // A single app-lifetime listener replaces one-per-component (and
    // one-per-card) listeners; nothing to tear down.
    window.addEventListener('resize', () => {
      sharedIsMobile.value = isMobileViewport()
    })
  }
  return sharedIsMobile
}

/** Reactive `isMobile` ref shared by every caller. */
export function useIsMobile() {
  return { isMobile: ensureSharedRef() }
}
